import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const CustomRadioButton = ({ id, name, checked, label, value, onChange }) => {
  return (
    <label
      htmlFor={id}
      className="group inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-[13px] font-medium text-text-primary"
    >
      <input
        type="radio"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        className="peer sr-only"
        value={value}
      />
      <span
        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors duration-200 peer-focus-visible:ring-2 peer-focus-visible:ring-indigo-500/50 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-surface ${
          checked
            ? "border-transparent bg-gradient-to-br from-accent to-accent-bright text-white shadow-lg shadow-indigo-500/20"
            : "border-edge-strong bg-input-bg group-hover:border-indigo-400/50"
        }`}
      >
        {checked && <FontAwesomeIcon icon={faCheck} className="text-[11px]" />}
      </span>
      {label}
    </label>
  );
};

export default CustomRadioButton;
